<template>
    <div id="modal-edit-note" class="modal-dialog modal-lg">
        <div class="modal-content">
            <header class="modal-header">
                <a class="h3" @click="$emit('mode', 'list')">
                    <!-- TODO extract svg -->
                    <svg height="17px" version="1.1" viewBox="0 0 16 17" width="16px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Android-APP-wireframes" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
                            <g id="4_inspirace-detail" fill="#5937B7" transform="translate(-20.000000, -44.000000)">
                                <g id="Top-Bar/Back-Icon">
                                    <polygon id="back-arrow" points="36 51.20625 23.8 51.20625 29.4 45.50125 28 44.075 20 52.225 28 60.375 29.4 58.94875 23.8 53.24375 36 53.24375"></polygon>
                                </g>
                            </g>
                        </g>
                    </svg>

                    {{ __('Notes') }}
                </a>

                <button aria-hidden="true" class="close" type="button" @click="$emit('mode', 'list')">
                    <svg-icon icon="close-modal" />
                </button>
            </header>
            <div class="modal-body">
                <div class="note-form">
                    <h3>{{ __('Edit note') }}</h3>

                    <form action="#" method="POST" novalidate @submit.prevent="submit">
                        <form-input-type-text
                            :errors="errors.name"
                            :label="__('Name')"
                            :value="form.name"
                            margin-bottom-double
                            name="name"
                            required
                        ></form-input-type-text>

                        <form-input-type-text-area
                            :errors="errors.body"
                            :label="__('Note')"
                            :value="form.body"
                            auto-grow
                            margin-bottom-double
                            name="body"
                            required
                        ></form-input-type-text-area>

                        <div class="note-alert">
                            <div class="input-wrapper form-input-checkbox form-input-checkbox--lg">
                                <input id="alert" type="checkbox" name="alert" v-model="hasAlertDate"> 
                                <label for="alert">{{ __('Edit note reminder') }}</label>
                            </div>

                            <form-input-type-datepicker
                                v-if="hasAlertDate"
                                :label="__('Date of reminder')"
                                :value="form.date ? moment(form.date).format('YYYY-MM-DD').toString() : moment().add(1, 'days').format('YYYY-MM-DD').toString()"
                                name="date"
                            ></form-input-type-datepicker>
                        </div>

                        <div class="btn-group">
                            <VButton :label="__('Save note')" position="center" size="lg" type="submit" />
                            <VButton :label="__('Delete')" position="center" variant="ghost" color="danger" @onClick="$emit('mode', 'delete')" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        patientId: {
            type: Number,
            required: true
        },
        note: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: Object.assign({}, this.note),
            errors: {},
            hasAlertDate: false
        }
    },
    mounted() {
        if(this.form && this.form.date && (moment(this.form.date).isValid())) {
            this.hasAlertDate = true
        }
    },
    methods: {
        async submit(event) {
            this.form.name = event.target.name.value
            this.form.body = event.target.body.value
            this.form.date = event.target.date ? moment(event.target.date.value).format('YYYY-MM-DD') : null
            this.form.coach_id = this.user.impersonator ? this.user.impersonator.coach_id : this.user.coach_id

            if(!this.hasAlertDate) {
                this.form.date = null;
            } else {
                if(this.form.date == null || !(moment(this.form.date).isValid())) {
                    this.form.date = moment().add(1, 'days').format('YYYY-MM-DD');
                }
            }

            const rolePrefix = this.user.role === 'coach' ? 'coaches' : 'doctors'

            await axios
                .put(`/${rolePrefix}/patients/${this.patientId}/notes/${this.note.id}`, this.form)
                .then((e) => {
                    $('#modal-note-edit').modal('hide')
                    e.data
                })
                .catch((e) => {
                    console.log(e.response)
                    this.errors = e.response.data.errors
                })

            this.$emit('update', this.form)
        }
    }
}
</script>
